module.exports = __webpack_public_path__ + "img/bg-car.6a63abd3.png";